import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../../Components/ModelContainer";
import Select from "../../../../Components/Select";
import Input from "../../../../Components/Input";
import ListDateInput from "../../../../Components/ListDateInput";
import Checkbox from "../../../../Components/Checkbox";
import ErrorContainer from "../../../../Components/ErrorContainer";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-date-picker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import DateInput from "../../../../Components/DateInput";
import { getFormData } from "../../../../../helpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";

const OrdrrOnline = (params) => {
  const dispatch = useDispatch();

  const ordrrOnlineData = useSelector(
    (state) => state?.settingReducer?.ordrrOnlineData?.order_online
  );

  const ordrrOnlineOptions = useSelector(
    (state) => state?.settingReducer?.ordrrOnlineData
  );

  const [sectionHide, setSectionHide] = useState({
    enableAccounts: false,
    useBrandColor: false,
  });
  const [checkboxVal, setCheckboxVal] = useState(0);
  useEffect(() => {
    dispatch(actions?.getOrdrrOnlineData());
  }, []);

  useEffect(() => {
    setSectionHide({
      enableAccounts:
        ordrrOnlineData?.ordrr_online_enable === "yes" ? true : false,
      useBrandColor:
        ordrrOnlineData?.use_brand_color_scheme === "yes" ? true : false,
    });
    console.log(ordrrOnlineDefaultState, "ordrrOnlineDefaultState");
    ordrrOnlineReset(ordrrOnlineDefaultState);
  }, [ordrrOnlineData]);
  const ordrrOnlineDefaultState = {
    ordrr_online_enable: ordrrOnlineData?.ordrr_online_enable ?? "",
    sales_type_id: ordrrOnlineData?.sales_type_id ?? "",
    pos_master_id: ordrrOnlineData?.pos_master_id ?? "",
    auto_fire_upon_customer_submit:
      ordrrOnlineData?.auto_fire_upon_customer_submit ?? "",
    minimum_pick_up_buffer: ordrrOnlineData?.minimum_pick_up_buffer ?? "",
    categorisation_preference: ordrrOnlineData?.categorisation_preference ?? "",
    use_brand_color_scheme: ordrrOnlineData?.use_brand_color_scheme ?? "",
    brand_main_color: ordrrOnlineData?.brand_main_color ?? "",
    brand_highlight_color: ordrrOnlineData?.brand_highlight_color ?? "",
    is_primary_branding: ordrrOnlineData?.is_primary_branding ?? "",
  };
  const ordrrOnlineSchema = yup.object({
    ordrr_online_enable: yup.string().required(),
    sales_type_id:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    pos_master_id:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    auto_fire_upon_customer_submit:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    minimum_pick_up_buffer:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    categorisation_preference:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    use_brand_color_scheme:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    brand_main_color:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    brand_highlight_color:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
    is_primary_branding:
      sectionHide?.enableAccounts === "yes"
        ? yup.string()
        : yup.string().required(),
  });
  const {
    register: ordrrOnlineRegister,
    formState: { errors: ordrrOnlineError },
    handleSubmit: ordrrOnlineSubmit,
    reset: ordrrOnlineReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(ordrrOnlineSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: ordrrOnlineDefaultState,
  });

  function submitData(data) {
    console.log(data, "nnnnnnn");
    dispatch(actions?.postOrdrrOnlineData(data));
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div class="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="row lbrSettingMs d-flex">
                  <div className="col-md-12 modify">
                    <div className="shadowclass mt-md-4 mt-3 d-flex flex-wrap align-content-start">
                      <h4 className="event-alert w-100 mb-4">
                        Ordrr QR Settings
                      </h4>
                      <div className="d-flex calc-height w-100 flex-wrap">
                        <div className="settings-left-content fixed-pos col-3">
                          <ul className="settingMenus">
                            <li id="AccDetail_li" className="active">
                              <a href="#_" id="AccDetail_dayTime_a">
                                GENERAL
                              </a>
                            </li>

                            {sectionHide?.enableAccounts && (
                              <li id="FinSettings_li" className="">
                                <a href="#_" id="FinSettings_dayTime_a">
                                  BRAND SETTINGS
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>

                        <div className="settings-right-content scrolling col-9">
                          <form onSubmit={ordrrOnlineSubmit(submitData)}>
                            <div className="date-sec-scroll">
                              <div
                                id="AccDetail_dayTime_div"
                                className="row-fluid scroll-change full_div"
                                day_time="AccDetail"
                              >
                                <div className="form-secs">
                                  <h4> General </h4>
                                  <ul class="ingredient-info edit-shift">
                                    <Select
                                      label={
                                        "Ordrr Online Enable for Accounts?"
                                      }
                                      formRegister={ordrrOnlineRegister}
                                      formError={ordrrOnlineError}
                                      formKey={"ordrr_online_enable"}
                                      optionsArray={ordrrOnlineOptions?.yes_no}
                                      onChange={(e) => {
                                        setSectionHide({
                                          ...sectionHide,
                                          enableAccounts:
                                            e.target.value === "yes"
                                              ? true
                                              : false,
                                        });
                                      }}
                                    />
                                    {sectionHide?.enableAccounts && (
                                      <>
                                        <Select
                                          label={
                                            "Default Sales Type Menu Inherited"
                                          }
                                          formRegister={ordrrOnlineRegister}
                                          formError={ordrrOnlineError}
                                          formKey={"sales_type_id"}
                                          optionsArray={
                                            ordrrOnlineOptions?.salesTypes
                                          }
                                          onChange={(e) => {}}
                                        />
                                        <Select
                                          label={"Default Order Station"}
                                          formRegister={ordrrOnlineRegister}
                                          formError={ordrrOnlineError}
                                          formKey={"pos_master_id"}
                                          optionsArray={
                                            ordrrOnlineOptions?.posMasters
                                          }
                                          onChange={(e) => {}}
                                        />
                                        <Select
                                          label={
                                            "Auto-fire Upon Customer Submit?"
                                          }
                                          formRegister={ordrrOnlineRegister}
                                          formError={ordrrOnlineError}
                                          formKey={
                                            "auto_fire_upon_customer_submit"
                                          }
                                          optionsArray={
                                            ordrrOnlineOptions?.yes_no
                                          }
                                          onChange={(e) => {}}
                                        />
                                        <Select
                                          label={"Minimum Pick-Up Buffer"}
                                          formRegister={ordrrOnlineRegister}
                                          formError={ordrrOnlineError}
                                          formKey={"minimum_pick_up_buffer"}
                                          optionsArray={
                                            ordrrOnlineOptions?.minimumBuffer
                                          }
                                          onChange={(e) => {}}
                                        />
                                        <Select
                                          label={"Categorisation Preference "}
                                          formRegister={ordrrOnlineRegister}
                                          formError={ordrrOnlineError}
                                          formKey={"categorisation_preference"}
                                          optionsArray={[
                                            {
                                              value: "1",
                                              label: "Sub Category",
                                            },
                                            { value: "2", label: "Sub Class" },
                                          ]}
                                          onChange={(e) => {}}
                                        />
                                      </>
                                    )}
                                  </ul>
                                </div>
                              </div>
                              {sectionHide?.enableAccounts && (
                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4>Brand Settings</h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <Select
                                        label={"Use Brand Color Scheme?"}
                                        formRegister={ordrrOnlineRegister}
                                        formError={ordrrOnlineError}
                                        formKey={"use_brand_color_scheme"}
                                        optionsArray={
                                          ordrrOnlineOptions?.yes_no
                                        }
                                        onChange={(e) => {
                                          setSectionHide({
                                            ...sectionHide,
                                            useBrandColor:
                                              e.target.value === "yes"
                                                ? true
                                                : false,
                                          });
                                        }}
                                      />
                                      {sectionHide?.useBrandColor && (
                                        <>
                                          <li>
                                            <label>Brand Main Color</label>
                                            <div class={` input-group `}>
                                              <input
                                                type="color"
                                                {...ordrrOnlineRegister(
                                                  "brand_main_color"
                                                )}
                                              />
                                              {
                                                <ErrorContainer
                                                  errors={ordrrOnlineError}
                                                  name={"brand_main_color"}
                                                />
                                              }
                                            </div>
                                          </li>
                                          <li>
                                            <label>Brand Highlight Color</label>
                                            <div class={` input-group `}>
                                              <input
                                                type="color"
                                                {...ordrrOnlineRegister(
                                                  "brand_highlight_color"
                                                )}
                                              />
                                              {
                                                <ErrorContainer
                                                  errors={ordrrOnlineError}
                                                  name={"brand_highlight_color"}
                                                />
                                              }
                                            </div>
                                          </li>
                                          <Checkbox
                                            label={"Primary Branding"}
                                            formRegister={ordrrOnlineRegister}
                                            formError={ordrrOnlineError}
                                            formKey={"use_brand_color_scheme"}
                                            isModal={false}
                                            onClick
                                            notRequired
                                            setCheckboxVal={setCheckboxVal}
                                            setFormField={setValue}
                                            //
                                            checkboxVal={checkboxVal}
                                          />
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div class="paddingtb10">
                              <div class="btns d-flex justify-content-end">
                                <button
                                  class="btn"
                                  name="submit"
                                  type="submit"
                                  id="cancel"
                                >
                                  Cancel
                                </button>
                                <button class="btn" name="submit" type="submit">
                                  Save
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default OrdrrOnline;
